import { useMutation, useQueryCache } from "react-query";
import { useSelector } from "react-redux";
import networkSelectors from "../../../../selectors/network";
import { getInspectionQueryKey } from "./useInspection";
import { deleteInspectionItemStatus } from "../../api/inspections/deleteInspectionItemStatus";

interface Params {
  id: number;
  sectionId: number;
  itemId: number;
}

export default function useDeleteInspectionItemStatus() {
  const queryCache = useQueryCache();
  const networkHeaders = useSelector(networkSelectors.defaultHeaders);
  const [resetInspectionItemStatus, resetInspectionItemStatusState] = useMutation(
    deleteInspectionItemStatus(networkHeaders),
  );

  const handleResetInspectionItemStatus = ({ id, sectionId, itemId }: Params) => {
    return resetInspectionItemStatus(
      { id, sectionId, itemId },
      {
        onSuccess: () => {
          const inspectionQueryKey = getInspectionQueryKey(id);
          queryCache.invalidateQueries(inspectionQueryKey);
        },
      },
    );
  };

  return {
    resetInspectionItemStatus: handleResetInspectionItemStatus,
    isLoading: resetInspectionItemStatusState.isLoading,
  };
}
